import { EnvsNamesMap } from '@/constants';

export default {
  SERVER_URL: 'https://prices.master.rhapsody.vet/api',
  API_URL: 'https://prices.master.rhapsody.vet/api/api',
  AUTH_URL: 'https://prices.master.rhapsody.vet/api/auth',
  ENV: EnvsNamesMap.MASTER
};
